var BpDuplCheckController = (function () {
    //  = !this.oppVersion || this.oppVersion <= this.OPP_VERSION_4 ?
    //     this.mysaCheckData && angular.isDefined(this.mysaCheckData.DUPMYSA) ? [this.mysaCheckData.DUPMYSA.data] : undefined;:
    // ;
    function BpDuplCheckController(topic, $injector, env, $stateParams, $scope) {
        this.topic = topic;
        this.$injector = $injector;
        this.env = env;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        //private OPP_VERSION_3: number = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.tableName = 'BP Duplicate Check';
        this.visible = false;
        this.filterDisplay = false;
        if (this.topic.checksData.uiVersion === this.OPP_VERSION_4) {
            this.comp = 'dc_mysa_v4';
        }
        else if (this.topic.checksData.uiVersion > this.OPP_VERSION_4) {
            this.comp = 'dc_v5';
        }
        else {
            this.comp = 'dc_mysa';
        }
        this.oppVersion = this.topic.topic.version;
        var checksData = _.get(this, 'topic.checksData.result');
        if ((!this.oppVersion || this.oppVersion <= this.OPP_VERSION_4) && checksData.DUPMYSA) {
            this.mysaResult = [checksData.DUPMYSA.data];
        }
        else if (this.oppVersion && this.oppVersion >= this.OPP_VERSION_5 && checksData.DUP && checksData.DUP.data) {
            this.mysaEiResult = [JSON.parse(JSON.stringify(checksData.DUP.data))];
            this.mysaEiResult[0].isEi = true;
            this.mysaSsaResult = [JSON.parse(JSON.stringify(checksData.DUP.data))];
            this.mysaSsaResult[0].isEi = false;
        }
    }
    BpDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    BpDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    BpDuplCheckController.prototype.isSectionEnabled = function () {
        if (this.oppVersion && this.oppVersion >= this.OPP_VERSION_5) {
            return true;
        }
        else {
            return _.get(this, 'mysaResult') !== undefined
                ? !this.mysaResult.isError
                : false;
        }
    };
    BpDuplCheckController.prototype.isError = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            if (_.get(this, 'topic.checksData.result.DUP.isError') === true) {
                return true;
            }
        }
        else {
            // update for v4 if necessary
            return false;
        }
    };
    BpDuplCheckController.$inject = ['topic', '$injector', 'env', '$stateParams', '$scope', '_'];
    return BpDuplCheckController;
}());
var BpDuplCheckComponent = (function () {
    function BpDuplCheckComponent() {
        this.templateUrl = 'detail-table-bp-duplcheck.html';
        this.controllerAs = 'vm';
        this.controller = BpDuplCheckController;
    }
    return BpDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableBpCheck', new BpDuplCheckComponent());

//# sourceMappingURL=detail.table.bp.duplcheck.component.js.map
